import api from "../../api";
import {typedQuery} from "../typing";

export const customPromptCategories = typedQuery(["customPromptCategories"], async () => {
  return await api.customPrompts.listCategories();
});

export const customPrompts = typedQuery(["customPrompts"], async () => {
  return await api.customPrompts.list();
});
